// extracted by mini-css-extract-plugin
export default {"control":"Poste_control__9P-Va","wrapper":"Poste_wrapper__gTO60","confirm":"Poste_confirm__+ztsT","price":"Poste_price__OlRnc"};